import { getCategory } from "./utils";

export const transformMediaDataToItems = (skuData, isFirstSixExt = true, mobileView = false) => {
  let positionMap = {
    360: skuData?.team_config?.["360"]?.position || 1,
    video: skuData?.team_config?.["video"]?.position || 0,
    image: skuData?.team_config?.["image"]?.position || 0,
  };
  let mediaTypes = Object.entries(positionMap)
    .filter(([_, position]) => position !== undefined)
    .sort(([_, posA], [__, posB]) => posA - posB)
    .map(([type]) => type);
  mediaTypes.push("360Int");
  const items = [];
  for (const type of mediaTypes) {
    if (skuData[type]) {
      if (type === "image") {
        if (isFirstSixExt) {
          //pick category wise images
          if (Object.keys(skuData?.image || {}).length > 0) {
            if (skuData?.image?.exterior?.length > 0) {
              items.push(
                ...(skuData?.image?.exterior || []).map((item) => ({
                  type: "image",
                  data: item,
                  category: "exterior",
                }))
              );
            }
            if (skuData?.image?.["360_exterior"]?.length > 0) {
              items.push(
                ...(skuData?.image?.["360_exterior"] || []).map((item) => ({
                  type: "image",
                  data: item,
                  category: "exterior",
                }))
              );
            }
            if (skuData?.image?.interior?.length > 0) {
              items.push(
                ...(skuData?.image?.interior || []).map((item) => ({
                  type: "image",
                  data: item,
                  category: "interior",
                }))
              );
            }

            const otherImageKeys = Object.keys(skuData["image"]).filter(
              (key) => !["interior", "exterior", "360_exterior"].includes(key)
            );

            for (const key of otherImageKeys) {
              if (skuData["image"][key]?.length > 0) {
                items.push(
                  ...skuData["image"][key].map((item) => ({
                    type: "image",
                    data: item,
                    category: "additional",
                  }))
                );
              }
            }
          }
        } else if (skuData?.image?.length > 0) {
          // Prepare image items
          const imageItems =
            skuData?.["image"]?.map((item) => ({
              type: "image",
              data: item,
              category: getCategory(item?.image_category),
            })) || [];
          let videoItem = null;
          if (skuData?.video && !mobileView) {
            videoItem = {
              type: "video",
              data: skuData.video,
            };
          }
          if (videoItem) {
            // Insert at index 6 (7th position), or at the end if not enough images
            const insertIndex = Math.min(6, imageItems.length);
            imageItems.splice(insertIndex, 0, videoItem);
          }
          items.push(...imageItems);
        }
      } else {
        if (isFirstSixExt || mobileView) {
          items.push({
            type: type,
            data: skuData[type],
          });
        } else if (type !== "video") {
          items.push({
            type: type,
            data: skuData[type],
          });
        }
      }
    }
  }

  return items;
};
